import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

export const useCreateFromPackage = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (packageId: string) => {
      return await (await glynt).packages.createFromPackage(packageId);
    },

    ...callbacks,
  });
};
